/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link, useLocation } from 'react-router-dom';
import $ from 'jquery';

import { Helmet } from 'react-helmet-async';
import { AppDispatch } from '../../store';
import AwsAuthService from '../../services/aws-auth-service';
import { updateLoggedIn } from '../../modules/user';
import { RootState } from '../../rootReducer';
import topSlice from '../../modules/t-top/module';
import urls from '../../utils/urls';
import { getPageIdIfNecessary } from '../../utils/page-ids';
import { isLoading } from '../../modules/app';
import ApiCommon from '../../utils/api-common';
import McsBackendService from '../../services/mcs-backend-service';
import { handleCommonError } from '../../utils/handle-errors';
import { convertViewIdToLink, processingDateTimeToStringV2 } from '../../utils/format';
import TutorialModal from '../../basics/TutorialModal';
import SimpleModal from '../../basics/Modal';

// ヘッダの定義
const Header: React.FC = () => {
  const history = useHistory();
  const dispatch: AppDispatch = useDispatch();
  const location = useLocation();
  const { viewPattern } = useSelector((state: RootState) => state.pattern);
  const { updateSupport } = topSlice.actions;
  const { loggedIn } = useSelector((state: RootState) => state.user);

  const {
    top,
    selectedBankInfo,
  } = useSelector((state: RootState) => state.top);

  const {
    cognitoUserInfo,
  } = useSelector((state: RootState) => state.xLogin);

  const onClickLogoutButton = async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    // ローカルストレージがクリアされるため事前にapplication_bannerを取得する
    const localApplicationBannerLifespan = localStorage.getItem('application_banner_lifespan');
    // ログイン画面が上部に固定されてしまうのでメニューを閉じる
    $('.headerMenuCloseBtn').trigger('click');
    await AwsAuthService.signOut();
    dispatch(updateLoggedIn(false));
    sessionStorage.clear();
    localStorage.clear();
    // ローカルストレージがクリアされるため事前にapplication_bannerを取得したものを再設定する
    if (localApplicationBannerLifespan) {
      localStorage.setItem('application_banner_lifespan', `${new Date(localApplicationBannerLifespan)}`);
    }
    history.push(urls.LOGIN);
  };

  const headerElement = useRef<HTMLDivElement>(null);

  // 初回ログイン時のみのチュートリアルモーダル
  const [openTutorial, setOpenTutorial] = React.useState(false);
  const handleTutorialModalOpen = async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    setOpenTutorial(true);
  };
  const handleTutorialModalClose = () => {
    setOpenTutorial(false);
  };

  const [headerModalopen, setHeaderModalOpen] = React.useState(0);

  // ログアウト状態のユーザーには遷移先をログイン画面にする
  const linkCheck = async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, url:string) => {
    e.preventDefault();
    const urlList = ['E001', 'I001', 'J001', 'W001'];
    if (loggedIn) {
      if (urlList.includes(url) && selectedBankInfo.解約区分 === '1') {
        setHeaderModalOpen(1);
      } else {
        history.push(convertViewIdToLink(url));
      }
    } else {
      history.push(urls.LOGIN);
    }
  };

  const handleHeaderModalClose = () => {
    setHeaderModalOpen(0);
  };

  const isDisableHeaderPage = () => {
    if (location.pathname === urls.Q001) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    // window.addEventListener('load', loadListener);
    // window.addEventListener('resize', resizeListener);
    $('a[href^="#"]').not('a[href="#"], .no-scroll').on('click', function () {
      const href = $(this).attr('href');
      const sel = href === '#' || href === '' ? 'html' : href;
      const target = $(sel!);
      const position = target.offset()!.top - headerElement.current!.clientHeight;
      $('html, body').animate({ scrollTop: position }, 200, 'swing');
      return false;
    });

    const mediaQuery = window.matchMedia('(max-width: 768px)');
    handle(mediaQuery);
    mediaQuery.addListener(handle);
    function handle(mm: any) {
      if (mm.matches) {
        $('body, #header, .headerMainMenu, .headerMainMenu__menu__item__detail, .headerMainMenu__btns, .headerUserInfo, .headerMainMenu__menu__links').removeAttr('style');
        $('#header').removeClass('header--open');
        $('.headerMainMenu__menu__item').removeClass('headerMainMenu__menu__item--open');
      } else {
        $('body').removeClass('fixed');
        $('.headerMenuBtn').removeClass('open');
        $('.headerMainMenu__menu__item').removeClass('headerMainMenu__menu__item--open');
        $('body, .headerMainMenu, .headerMainMenu__menu__item__detail__list, .headerUserInfo').removeAttr('style');
        $(window).on('resize', () => {
          const windowHeight = $(window).height() ?? 0;
          if ($('#header').hasClass('header--open')) {
            $('.header--open').css('height', windowHeight);
            $('.headerUserInfo').css('top', windowHeight - 105);
            $('.headerMainMenu__btns').css('top', windowHeight - 80);
          }
        });
        $(window).on('scroll', () => {
          if ($('.headerMainMenu__menu__item').hasClass('headerMainMenu__menu__item--open')) {
            $('#header').removeClass('header--open');
            $('.headerMainMenu__menu__item').removeClass('headerMainMenu__menu__item--open');
            $('#header').animate({ height: 60 }, 200);
            $('.headerUserInfo, .headerMainMenu__btns').slideUp(200);
            $('.headerMainMenu__menu__links').fadeOut(100);
            $('.headerMainMenu__menu__item__detail').removeAttr('style');
          }
        });
      }
    }

    /* SP */
    $('.headerMainMenu__menu__item__detail__ttl').on('click', function () {
      $(this).next().slideToggle();
      $(this).closest('.headerMainMenu__menu__item').toggleClass('headerMainMenu__menu__item--open');
    });

    let scrollPosition: number;
    $('.headerMenuBtn').on('click', function () {
      if ($('.headerMenuBtn').hasClass('open')) {
        $('body').removeClass('fixed').css({ top: 0, overflow: 'visible', height: '100%' });
        $(this).removeClass('open');
        $('.headerMainMenu').slideUp();
        $('.headerUserInfo').hide();
        window.scrollTo(0, scrollPosition);
      } else {
        scrollPosition = $(window).scrollTop() ?? 0;
        $(this).addClass('open');
        $('.headerMainMenu').slideDown();
        $('.headerUserInfo').show();
        $('body').addClass('fixed').css({ top: -1 * scrollPosition, overflow: 'hidden', height: '100%' });
      }
    });

    /* PC */
    let menuClick = true;
    $('.headerMainMenu__menu__item__haschild').on('click', function () {
      if (menuClick) {
        menuClick = false;
        setTimeout(() => {
          menuClick = true;
        }, 500);
        const windowHeight = $(window).height() ?? 0;
        if ($('.headerMainMenu__menu__item__haschild').not($(this)).parent().hasClass('headerMainMenu__menu__item--open')) {
          $('#header').removeClass('header--open');
          $('.headerMainMenu__menu__item').removeClass('headerMainMenu__menu__item--open');
          $('#header').animate({ height: 60 }, 200);
          $('.headerUserInfo, .headerMainMenu__btns').slideUp(200);
          $('.headerMainMenu__menu__links').fadeOut(200);
          $('.headerMainMenu__menu__item__haschild').next().slideUp(200);
        }
        if (!$(this).parent().hasClass('headerMainMenu__menu__item--open')) {
          $.when(
            $('#header').addClass('header--open'),
            $(this).parent().addClass('headerMainMenu__menu__item--open'),
            $('#header').animate({ height: windowHeight }, 300),
            $('.headerUserInfo').css('top', windowHeight - 105),
            $('.headerMainMenu__btns').css('top', windowHeight - 80),
            $(this).next().slideDown(200),
            $('.headerMenuCloseBtn').show(),
            $('body').addClass('fixed').css({ top: -1 * scrollPosition, overflow: 'hidden', height: '100%' }),
          ).done(() => {
            $('.headerUserInfo, .headerMainMenu__btns').slideDown(100);
            $('.headerMainMenu__menu__links').fadeIn(100);
          });
        }
      }
    });

    $('.headerMenuCloseBtn').on('click', (e) => {
      e.preventDefault();
      $('#header').removeClass('header--open');
      $('.headerMainMenu__menu__item__haschild').parent().removeClass('headerMainMenu__menu__item--open');
      $('#header').animate({ height: 60 }, 200);
      $('.headerUserInfo, .headerMainMenu__btns').slideUp(200);
      $('.headerMainMenu__menu__links').fadeOut(100);
      $('.headerMainMenu__menu__item__haschild').next().slideUp(200);
      $('body').removeClass('fixed').css({ top: 0, overflow: 'visible', height: '100%' });
      $('.headerMenuCloseBtn').hide();
    });

    return () => {
      $('.headerMenuBtn').off('click');
      $(window).off('scroll');
      $('.headerMainMenu__menu__item__detail__ttl').off('click');
      $(window).off('resize');
      $('.accordionList__item__ttl').off('click');
      $('a[href^="#"]').not('a[href="#"], .no-scroll').off('click');
      $('.headerMainMenu__menu__item__haschild').off('click');
      $('.headerMenuCloseBtn').off('click');
    };
  }, []);

  // ？（お客様サポート）ボタンの処理
  const onClickSupportButton = async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    try {
      dispatch(isLoading(true));
      const commonPart = await ApiCommon.getCommonPart('T001', 'T-02', '', viewPattern);
      const dataPart = {
        データ部: {
          会員番号: await AwsAuthService.getUsername(),
          口座枝番: selectedBankInfo.口座枝番,
          メッセージＡ１タイトル: '',
          メッセージＡ１: '',
          メッセージＡ１遷移先機能: '',
          メッセージＡ１ボタン名: '',
          メッセージＡ２タイトル: '',
          メッセージＡ２: '',
          メッセージＡ２遷移先機能: '',
          メッセージＡ２ボタン名: '',
          メッセージＡ３タイトル: '',
          メッセージＡ３: '',
          メッセージＡ３遷移先機能: '',
          メッセージＡ３ボタン名: '',
          メッセージＡ４タイトル: '',
          メッセージＡ４: '',
          メッセージＡ４遷移先機能: '',
          メッセージＡ４ボタン名: '',
          メッセージＡ５タイトル: '',
          メッセージＡ５: '',
          メッセージＡ５遷移先機能: '',
          メッセージＡ５ボタン名: '',
          メッセージＡ６タイトル: '',
          メッセージＡ６: '',
          メッセージＡ６遷移先機能: '',
          メッセージＡ６ボタン名: '',
          メッセージＡ７タイトル: '',
          メッセージＡ７: '',
          メッセージＡ７遷移先機能: '',
          メッセージＡ７ボタン名: '',
          メッセージＡ８タイトル: '',
          メッセージＡ８: '',
          メッセージＡ８遷移先機能: '',
          メッセージＡ８ボタン名: '',
        },
      };
      const json = await McsBackendService.request(Object.assign(commonPart, dataPart));
      dispatch(updateSupport(json.データ部));
      history.push(urls.T005);
    } catch (err) {
      handleCommonError(err);
    } finally {
      dispatch(isLoading(false));
    }
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex , nofollow" />
      </Helmet>
      { !isDisableHeaderPage()
      && (
        <header id="header" ref={headerElement} className="header-ja">
          <div className="headerWrapper">
            <div className="headerLogo">
              <Link to={urls.TOP}>
                <img src="/img/A/img_header_logo.png" alt="レイク" width="102" />
              </Link>
              <span className="pageId">{getPageIdIfNecessary(location.pathname)}</span> {/* 画面ID 本番では表示しない予定 */}
            </div>
            <ul className="headerSubMenu">
              <li>
                <Link to={urls.TT005}>
                  <span className="headerSubMenu__icon">
                    <img src="/img/A/icon_headerSubMenu_support.png" alt="サポート" />
                  </span>サポート
                </Link>
              </li>
              <li>
                <a href="/" onClick={onClickSupportButton}>
                  <span className={`headerSubMenu__icon ${top.新着メッセージ有無区分 === '0' ? 'headerSubMenu__icon' : 'headerSubMenu__icon--active'}`}>
                    <img src="/img/A/icon_headerSubMenu_notice.png" alt="お知らせ" />
                  </span>お知らせ
                </a>
              </li>
            </ul>
            <div className="headerMainMenu">
              <ul className="headerMainMenu__menu">
                <li className="headerMainMenu__menu__item">
                  <a href="/" onClick={(e) => linkCheck(e, 'T001')}>ホーム</a>
                </li>
                <li className="headerMainMenu__menu__item">
                  <span className="headerMainMenu__menu__item__haschild">ご利用状況</span>
                  <div className="headerMainMenu__menu__item__detail">
                    <div className="headerMainMenu__menu__item__detail__inner">
                      <div className="headerMainMenu__menu__item__detail__ttl">ご利用状況</div>
                      <ul className="headerMainMenu__menu__item__detail__list">
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'A001')}>ご利用状況・ご契約内容</a></li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li className="headerMainMenu__menu__item">
                  <span className="headerMainMenu__menu__item__haschild">借りるとき</span>
                  <div className="headerMainMenu__menu__item__detail">
                    <div className="headerMainMenu__menu__item__detail__inner">
                      <div className="headerMainMenu__menu__item__detail__ttl">借りるとき</div>
                      <ul className="headerMainMenu__menu__item__detail__list">
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'TT001')}>借りるとき</a></li>
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'E001')}>お借入れ</a></li>
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'F001')}>お借入れの申込状況確認</a></li>
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'H001')}>ご利用限度額の増額</a></li>
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'U001')}>おまとめローン ご契約手続き</a></li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li className="headerMainMenu__menu__item">
                  <span className="headerMainMenu__menu__item__haschild">返すとき</span>
                  <div className="headerMainMenu__menu__item__detail">
                    <div className="headerMainMenu__menu__item__detail__inner">
                      <div className="headerMainMenu__menu__item__detail__ttl">返すとき</div>
                      <ul className="headerMainMenu__menu__item__detail__list">
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'TT003')}>返すとき</a></li>
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'B001')}>ご返済情報の確認</a></li>
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'C001')}>毎月のご返済日変更</a></li>
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'I001')}>Web返済サービス</a></li>
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'J001')}>口座振替（自動引落し）</a></li>
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'W001')}>ご返済時の振込入金口座照会</a></li>
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'S001')}>お預り金の返却</a></li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li className="headerMainMenu__menu__item">
                  <span className="headerMainMenu__menu__item__haschild">各種お手続き</span>
                  <div className="headerMainMenu__menu__item__detail">
                    <div className="headerMainMenu__menu__item__detail__inner">
                      <div className="headerMainMenu__menu__item__detail__ttl">各種お手続き</div>
                      <ul className="headerMainMenu__menu__item__detail__list">
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'TT002')}>各種お手続き</a></li>
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'L001')}>収入証明書類の提出</a></li>
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'K001')}>お客さま情報の確認・変更</a></li>
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'M001')}>アカウント情報の変更</a></li>
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'O001')}>カードに関するお手続き</a></li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li className="headerMainMenu__menu__item">
                  <span className="headerMainMenu__menu__item__haschild">サポート・お問合せ</span>
                  <div className="headerMainMenu__menu__item__detail">
                    <div className="headerMainMenu__menu__item__detail__inner">
                      <div className="headerMainMenu__menu__item__detail__ttl">サポート・お問合せ</div>
                      <ul className="headerMainMenu__menu__item__detail__list">
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'P002')}>お問合せフォーム</a></li>
                        <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'P006')}>お電話でのお問合せ</a></li>
                        <li className="headerMainMenu__menu__item">
                          <a href="/" onClick={handleTutorialModalOpen}>会員ページでできること</a>
                        </li>
                      </ul>
                      <TutorialModal open={openTutorial} onClose={handleTutorialModalClose} />
                    </div>
                  </div>
                </li>
                <li className="headerMainMenu__menu__item"><a href="/" onClick={(e) => linkCheck(e, 'T005')}>お知らせ</a></li>
                <li className="headerMainMenu__menu__item"><a href="/" onClick={onClickLogoutButton}>ログアウト</a></li>
              </ul>
              <ul className="headerMainMenu__menu__links">
                <li className="headerMainMenu__menu__links__item">
                  <a href="/" onClick={(e) => linkCheck(e, 'T001')}>
                    <span className="headerMainMenu__menu__links__item__icon"><img src="/img/A/icon_headerSiteMenu_home.png" alt="ホーム" className="textIconLeft__icon__img" /></span>
                    ホーム
                  </a>
                </li>
                <li className="headerMainMenu__menu__links__item">
                  <a href="/" onClick={onClickLogoutButton}><span className="headerMainMenu__menu__links__item__icon"><img src="/img/A/icon_headerSiteMenu_logout.png" alt="ログアウト" className="textIconLeft__icon__img" /></span>
                    ログアウト
                  </a>
                </li>
              </ul>
              <ul className="headerMainMenu__btns">
                <li className="headerMainMenu__btns__item">
                  <a href="/" className="btn btn--cv btn--iconLeft" onClick={(e) => linkCheck(e, 'I001')}>
                    <span className="btn--icon__icon">
                      <img src="/img/A/icon_headerMainMenu__btns_refund.png" alt="ご返済" className="btn--icon__img" />
                    </span>ご返済
                  </a>
                </li>
                <li className="headerMainMenu__btns__item">
                  <a href="/" className="btn btn--cv btn--iconLeft" onClick={(e) => linkCheck(e, 'E001')}>
                    <span className="btn--icon__icon">
                      <img src="/img/A/icon_headerMainMenu__btns_loan.png" alt="お借入れ" className="btn--icon__img" />
                    </span>お借入れ
                  </a>
                </li>
              </ul>
              <div className="headerMenuCloseBtn forPC"><span /></div>
            </div>
            <SimpleModal
              open={headerModalopen === 1}
              onClose={handleHeaderModalClose}
              id="modal"
              className="modal"
            >
              <div className="modal__inner">
                <div className="blockNarrow">
                  <p>解約済みのため、ご利用いただけません。</p>
                </div>
              </div>
            </SimpleModal>
            <div className="headerMenuBtn">
              <div className="headerMenuBtn__icon"><span /><span /><span /></div>
            </div>
            <div className="headerUserInfo">
              <p>
                <span className="fs2XS">前回ログイン：{processingDateTimeToStringV2(cognitoUserInfo.lastLoginDate)}</span>
              </p>
            </div>
          </div>
        </header>
      )}
    </>
  );
};

export default Header;
